import * as signalR from "@microsoft/signalr";

var urlPrefix = process.env.VUE_APP_OMNI_BASE_URL;

const connection = new signalR.HubConnectionBuilder()
  .withUrl(urlPrefix + "/clientDashboardHub")
  .configureLogging(signalR.LogLevel.Information)
  .build();

//restart connection if it closes
connection.serverTimeoutInMilliseconds = 300000;
connection.keepAliveIntervalInMilliseconds = 300000;

async function start() {
  try {
    await connection.start();
    console.log("Connection to clientDashboardHub started successfully");
  } catch (err) {
    console.log(`Error starting hub connection: ${err}`);
    setTimeout(() => start(), 60000);
  }
}

connection.onclose(async () => {
  await start();
});

start();
export { connection };